function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

class SectionId {
  static #separator = '__';

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section id (e.g. 'template--22224696705326')
  static parseId(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[0];
  }

  // for a qualified section id (e.g. 'template--22224696705326__main'), return just the section name (e.g. 'main')
  static parseSectionName(qualifiedSectionId) {
    return qualifiedSectionId.split(SectionId.#separator)[1];
  }

  // for a section id (e.g. 'template--22224696705326') and a section name (e.g. 'recommended-products'), return a qualified section id (e.g. 'template--22224696705326__recommended-products')
  static getIdForSection(sectionId, sectionName) {
    return `${sectionId}${SectionId.#separator}${sectionName}`;
  }
}

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    if (
      event.currentTarget.parentElement.parentElement &&
      event.currentTarget.parentElement.parentElement.classList.contains('product__accordion')
    ) {
      event.preventDefault();
    } else {
      // console.log("summary click function run")
      document.querySelectorAll("#menu-drawer details").forEach((e) => {
        if(e != event.currentTarget.closest('details')){
           e.removeAttribute("open");
        }
      })
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    }
    // event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

// document.querySelectorAll('.menu-drawer__submenu').forEach((submenu) => {
//   submenu.addEventListener('mouseleave', this.onSubmenuMouseLeave.bind(this));
// });

function onSubmenuMouseLeave(event) {
  const submenu = event.currentTarget;
  const detailsElement = submenu.parentNode;
  const summaryElement = detailsElement.querySelector('summary');
  const animatedElements = detailsElement.querySelectorAll('.scroll-trigger.animate--slide-in');
  animatedElements.forEach((element) => {
    element.classList.remove('animate--slide-in', 'scroll-trigger--offscreen');
    void element.offsetWidth;
  });
  setTimeout(() => {
    detailsElement.classList.remove('menu-opening');
    detailsElement.removeAttribute('open');
    summaryElement.setAttribute('aria-expanded', false);
    summaryElement.classList.remove('submenu-open');
    const parentMenuElement = detailsElement.closest('.has-submenu');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
  }, 100);
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  // Pause YouTube iframes
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"pauseVideo","args":""}', '*'
    );
  });

  // Pause Vimeo iframes
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });

  // ❌ Removed HTML5 <video> pause (so autoplay video keeps playing)

  // Pause Shopify product models
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    if(this.input){
      this.input.addEventListener('change', this.onInputChange.bind(this));
    }
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
      if(this.closest("[data-cart-item-id]")){
        let itemElementMinus = this.closest("[data-cart-item-id]");
        this.triggerRemoveFromCartEvent(itemElementMinus);
      }
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    if(this.input){
      const value = parseInt(this.input.value);
      if (this.input.min) {
        const buttonMinus = this.querySelector(".quantity__button[name='minus']");
        buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
        
        
      }
      if (this.input.max) {
        const max = parseInt(this.input.max);
        const buttonPlus = this.querySelector(".quantity__button[name='plus']");
        buttonPlus.classList.toggle('disabled', value >= max);
      }
    }
  }
  triggerRemoveFromCartEvent(itemEl) {
    if (!itemEl) return;

    const cartDrawer = document.querySelector("cart-drawer-items");
    const totalValue = cartDrawer
      ? parseFloat(cartDrawer.getAttribute("data-cart-total"))
      : undefined;

    const id = itemEl.getAttribute("data-cart-item-id");

    const name =
      itemEl.getAttribute("data-cart-item-title") ||
      itemEl.querySelector(".cart-item__title")?.innerText.trim();

    const brand =
      itemEl.getAttribute("data-cart-item-vendor") ||
      itemEl.querySelector(".cart-item__vendor")?.innerText.trim();

    const category =
      itemEl.getAttribute("data-cart-item-type") ||
      itemEl.querySelector(".cart-item__type")?.innerText.trim();

    const price =
      parseFloat(itemEl.getAttribute("data-cart-item-price")) ||
      parseFloat(itemEl.querySelector("[data-price]")?.dataset.price);

    const itemData = {
      id: id ? `shopify_${id}` : undefined,
      name,
      brand,
      category,
      price,
      quantity: 1
    };

    // Remove undefined item keys
    Object.keys(itemData).forEach(
      key => itemData[key] === undefined && delete itemData[key]
    );

    const ecommerceData = {
      value: totalValue,
      currency: "ILS",
      items: [itemData]
    };

    // Remove undefined value
    if (ecommerceData.value === undefined) {
      delete ecommerceData.value;
    }

    dataLayer.push({
      event: "remove_from_cart",
      ecommerce: ecommerceData
    });
}

}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) => {
      if (window.matchMedia('(min-width: 990px)').matches) {
        if (summary.classList.contains('font-menu')) {
          // summary.addEventListener('mouseover', this.onSummaryMouseOver.bind(this));
          // summary.addEventListener('mouseout', this.onSummaryMouseOut.bind(this));
        } else {
          summary.addEventListener('click', this.onSummaryClick.bind(this));
        }
      } else {
        summary.addEventListener('click', this.onSummaryClick.bind(this));
      }
    });
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryMouseOut(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const submenu = detailsElement.querySelector('.menu-drawer__submenu');

    const isHoveringSubmenu = submenu && submenu.contains(event.relatedTarget);

    if (!isHoveringSubmenu) {
      setTimeout(() => {
        detailsElement.classList.remove('menu-opening');
        detailsElement.removeAttribute('open');
        summaryElement.setAttribute('aria-expanded', false);
        summaryElement.classList.remove('submenu-open');
        parentMenuElement && parentMenuElement.classList.remove('submenu-open');
        const animatedElements = detailsElement.querySelectorAll('.scroll-trigger.animate--slide-in');
        animatedElements.forEach((element) => {
          element.classList.remove('animate--slide-in', 'scroll-trigger--offscreen');
          void element.offsetWidth;
        });
      }, 100);
    }
  }

  onSummaryMouseOver(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const animatedElements = detailsElement.querySelectorAll('.scroll-trigger');
    animatedElements.forEach((element) => {
      element.classList.add('animate--slide-in');
    });
    setTimeout(() => {
      detailsElement.classList.add('menu-opening');
      detailsElement.setAttribute('open', '');
      summaryElement.setAttribute('aria-expanded', true);
      summaryElement.classList.add('submenu-open');
    }, 100);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        // parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
        if (event.srcElement.classList.contains('font-menu')) {
          const hideElements = document.querySelectorAll('.hide');

          hideElements.forEach((element) => {
            element.classList.remove('hide');
          });
        }
      }, 50);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    }, 200);
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `0px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `0px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (window.matchMedia('(min-width: 750px)').matches) {
          if (event.target.classList.contains('media--gradient__modal')) {
            if (event.target.classList.contains('zoom')) {
              event.target.style.setProperty('zoom', '1');
              event.target.style.setProperty('cursor', 'zoom-in');
              event.target.classList.remove('zoom');
            } else {
              event.target.style.setProperty('zoom', '2.5');
              event.target.style.setProperty('cursor', 'zoom-out');
              event.target.style.setProperty('margin', 'auto');
              event.target.classList.add('zoom');
            }
          }
          if (
            event.target.classList.contains('slider-button--next') ||
            event.target.parentElement.classList.contains('slider-button--next') ||
            event.target.parentElement.parentElement.classList.contains('slider-button--next')
          ) {
            this.updateThumbnailState();
          }
          if (
            event.target.classList.contains('slider-button--prev') ||
            event.target.parentElement.classList.contains('slider-button--prev') ||
            event.target.parentElement.parentElement.classList.contains('slider-button--prev')
          ) {
            this.updateThumbnailState();
          }
          if (event.target.classList == '') {
            return;
          }
        } else {
          if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) {
            this.hide();
          }
        }
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    if(this.closest('.shopify-section')){
      this.dataset.section = this.closest('.shopify-section').id.replace('shopify-section-', '');
    }
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();

    if (window.matchMedia('(min-width: 750px)').matches) {
      this.updateThumbnailState();
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    window.pauseAllMedia();
  }

  updateThumbnailState() {
    // Use requestAnimationFrame instead of setTimeout for better performance
    requestAnimationFrame(() => {
      const activeMedias = this.querySelectorAll('.product-media-item');
      const prevBtn = this.querySelector('.slider-button--prev');
      const nextBtn = this.querySelector('.slider-button--next');
      const totalItems = activeMedias.length;

      // Cache active media element to avoid querying DOM multiple times
      const activeMedia = Array.from(activeMedias).find((media) => media.classList.contains('active'));

      if (activeMedia) {
        const index = activeMedia.getAttribute('data-index');

        // Update thumbnails
        this.goToSlide(index);

        // Update button visibility
        const isFirst = index === '0';
        const isLast = index === (totalItems - 1).toString();
        prevBtn.style.display = isFirst ? 'none' : 'block';
        nextBtn.style.display = isLast ? 'none' : 'block';
      }

      // Use event delegation instead of adding listeners to each thumbnail
      this.addEventListener('click', (e) => {
        const thumb = e.target.closest('.thumbnail-item');
        if (thumb) {
          const targetIndex = thumb.getAttribute('data-index');
          this.goToSlide(targetIndex);
        }
      });
    });
  }

  goToSlide(index) {
    const thumbnailMedias = this.querySelectorAll('.thumbnail-item');

    thumbnailMedias.forEach((thumbnail) => {
      const thumbIndex = thumbnail.getAttribute('data-index');
      thumbnail.classList.toggle('active', thumbIndex === index);
    });
  }
}
customElements.define('modal-dialog', ModalDialog);

class BulkModal extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      if (this.innerHTML.trim() === '') {
        const productUrl = this.dataset.url.split('?')[0];
        fetch(`${productUrl}?section_id=bulk-quick-order-list`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const sourceQty = html.querySelector('.quick-order-list-container').parentNode;
            this.innerHTML = sourceQty.innerHTML;
          })
          .catch((e) => {
            console.error(e);
          });
      }
    };

    new IntersectionObserver(handleIntersection.bind(this)).observe(
      document.querySelector(`#QuickBulk-${this.dataset.productId}-${this.dataset.sectionId}`)
    );
  }
}

customElements.define('bulk-modal', BulkModal);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }

      // Workaround for safari iframe bug
      const formerStyle = deferredElement.getAttribute('style');
      deferredElement.setAttribute('style', 'display: block;');
      window.setTimeout(() => {
        deferredElement.setAttribute('style', formerStyle);
      }, 0);

      // image display none
      this.querySelector('.deferred-media__poster').classList.add('d-none');
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.counterElements = this.querySelectorAll('.counter-element');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;

      const currentCounterElement = this.querySelector(`[data-item="${this.currentPage}"]`);
      currentCounterElement && currentCounterElement.style.setProperty('background', '#34292C');
      if (this.counterElements) {
        this.counterElements.forEach((el) => {
          if (el.getAttribute('data-item') !== this.currentPage.toString()) {
            el.style.setProperty('background', '#B3ACA6');
          }
        });
      }
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      if (this.sliderItemsToShow[0].classList.contains('complementary-slide')) return;
      this.prevButton.setAttribute('disabled', 'disabled');
      this.prevButton.classList.add('d-none');
    } else {
      this.prevButton.removeAttribute('disabled');
      this.prevButton.classList.remove('d-none');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      if (this.sliderItemsToShow[this.sliderItemsToShow.length - 1].classList.contains('complementary-slide')) return;
      this.nextButton.setAttribute('disabled', 'disabled');
      this.nextButton.classList.add('d-none');
    } else {
      this.nextButton.removeAttribute('disabled');
      this.nextButton.classList.remove('d-none');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}
customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}
customElements.define('slideshow-component', SlideshowComponent);

if(document.body.classList.contains("matat-product-js")){
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);

      if(this.classList.contains('variant-product-card') && !this.classList.contains('no_image_change')) {
        if(this.querySelector('.product-form__input.listen_color_change') && this.querySelector('.product-form__input.image_switcher_activated')){
          this.querySelector('.product-form__input.listen_color_change').addEventListener('color_change', (e) => {
            const variant_image = this.updateSingleMedia(e.detail);
            if(variant_image){
              this.closest('.product-card-wrapper').querySelector('img.variant_image_element').srcset = variant_image;
              this.closest('.product-card-wrapper').querySelector('img.variant_image_element').src = variant_image;
            }
            this.closest('.product-card-wrapper').classList.add('variant_image_active');


            // Updating Variant Button
            const variant_details = this.getVariantDetails(e.detail);
            const $variant_input = this.closest('.product_quick_add_wrap').querySelectorAll('fieldset:not(.listen_color_change) .variant-button input');
            var $this = this;
            $variant_input.forEach(function(input){
              var this_value = input.getAttribute('value');
              switch(input.getAttribute('data-option')) {
                case "1":
                  var condition = variant_details.find((x)=>{
                      return x.available && x.option1 == this_value
                  });
                  $this.updateVariantButton(condition, input)
                  break;
                case "2":
                  var condition = variant_details.find((x)=>{
                      return x.available && x.option2 == this_value
                  });
                  $this.updateVariantButton(condition, input)
                  break;
                case "3":
                  var condition = variant_details.find((x)=>{
                      return x.available && x.option3 == this_value
                  });
                  $this.updateVariantButton(condition, input)
                  break;
                default:
              }
            });
          });
        }
      }
    }

    updateVariantButton(condition, input){
      if(condition){
        input.classList.remove('disabled')
      }else{
        input.classList.add('disabled')
      }
    }

    onVariantChange(e) {
      const fieldset = e.target.querySelectorAll('fieldset');
      let checked_count = 0;
      fieldset.forEach((item)=>{
        if(item.querySelectorAll('input[type="radio"]:checked').length > 0) {
          checked_count++;
        }
      })
      if(checked_count < fieldset.length ) return;
      const product_card = this.closest('.product-card_inline-variation');
      if(product_card) {
          this.updateOptions();
          this.updateMasterId();
          this.toggleAddButton(true, '', false);
          this.updateVariantStatuses();

          if (!this.currentVariant) {
            this.toggleAddButton(true, '', true);
            this.setUnavailable();
          } else {
            this.updateVariantInput();
            this.renderProductInfo();
          }
          this.quickAddToCart();
      } else {
        this.updateOptions();
        this.updateMasterId();
        this.toggleAddButton(true, '', false);
        this.updatePickupAvailability();
        this.removeErrorMessage();
        this.updateVariantStatuses();

        if(e.target.closest('.product-form__input').classList.contains('variation-color-wrapper')) {
          // this.updateMedia(e.target.value);
          this.slideToSelectedVariant(e.target.value);

        }

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
        } else {
          this.updateURL();
          this.updateVariantInput();
          this.renderProductInfo();
          this.updateShareUrl();
        }
      }
    }

    quickAddToCart() {
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        let enabledCounter = 0;
        const variant_form = this.querySelector('product-form').querySelector('form');

      inputWrappers.forEach((option, index) => {
        const selectedOptionInput = option.querySelector(':checked');
        if(selectedOptionInput && !selectedOptionInput.classList.contains('disabled')) {
          enabledCounter++;
          if(enabledCounter == inputWrappers.length) {
            variant_form.dispatchEvent(new Event('submit'))
            this.closest('.product-card-wrapper').querySelector('.quick_add_loading').classList.remove('hidden')
            this.closest('.product-card-wrapper').classList.add('adding_cart')
          }
        }
        // const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        // const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
        // this.setInputAvailability(optionInputs, availableOptionInputsValue)

        // if(product_card && option.classList.contains('visually-hidden')) {
        //   product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
        //   const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
        //   this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
        // }
      });
    }

    updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
      if(document.querySelector("check-availability")){
        document.querySelector("check-availability").setAttribute("data-selectedvariant",this.currentVariant.id);
        this.changelocationinventory(); 
      }
    }

    updateMedia(color) {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function(obj) { return obj.featured_media.preview_image.src; }))];
      let main_images = [],
          thumb_images = [];

      for (let img_src of variant_images) {
        const main_classes = ['product__media-item', 'grid__item', 'slider__slide']
        let main_img = document.createElement("li");
        main_img.classList.add(...main_classes);
        main_img.innerHTML = `<a href="${img_src}" data-pswp-width="1000" data-pswp-height="1500">
                      <div class="product-media-container media-type-image media-fit-contain gradient" style="--ratio: 0.6666666666666666; --preview-ratio: 0.6666666666666666;">
                      <div class="product__media media media--transparent has_zoom_element">
                            <img src="${img_src}&amp;width=1946" alt="">
                          </div>
                      </div>
                    </a>`;
        main_images.push(main_img);

        const thumb_classes = ['thumbnail-list__item', 'slider__slide']
        let thumb_img = document.createElement("li");
        thumb_img.classList.add(...thumb_classes);
        thumb_img.innerHTML = `<button class="thumbnail global-media-settings global-media-settings--no-shadow"><img src="${img_src}&amp;width=416" alt=""></button>`;
        thumb_images.push(thumb_img);
      }

      const main_product_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.product__media-list[data-flickity]'));
      const main_old_cells = main_product_gallery.cells.map(cell => cell.element);
      if(main_old_cells.length) {
        main_product_gallery.remove(main_old_cells);
      }
      main_product_gallery.insert( main_images, 0 );
      main_product_gallery.select(0);

      const thumb_gallery = Flickity.data(this.closest('.single_main_product_wrapper').querySelector('.thumbnail_slider_side[data-flickity]'));
      const thumb_old_cells = thumb_gallery.cells.map(cell => cell.element);
      if(thumb_old_cells.length) {
        thumb_gallery.remove(thumb_old_cells);
      }
      setTimeout(() =>{
        if(thumb_images.length>4) {
          thumb_gallery.insert( thumb_images, 0 );
        } else {
          let flktyOptions = JSON.parse(thumb_gallery.element.dataset.flickity);
          delete flktyOptions.wrapAround;
          flktyOptions.contain = true;
          thumb_gallery.insert( thumb_images, 0 );

          setTimeout(() =>{
            thumb_gallery.destroy();
            let new_flickity = new Flickity(thumb_gallery.element, flktyOptions);
            new_flickity.reposition();
          },50);
        }
      },20);
    }

    slideToSelectedVariant(color){
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      var variant_images = [...new Set(this.getVariantData().filter(variant => variant.title.includes(color)).map(function(obj) { return obj.featured_media.preview_image.src; }))];
      var target_image = variant_images[0];
      var taeget_index = document.querySelector(`.slider__slide a[href="${target_image}"]`).closest('.product__media-item').dataset.index;
      var flkty = Flickity.data(document.querySelector('.product-slider-gallery[data-flickity]'));
      if(flkty) {
        flkty.select(taeget_index)
      }
      return;
    }

    updateSingleMedia(color) {
      const single_variant_data = this.getVariantData().find(variant => variant.title.includes(color));
      const variant_img_src = single_variant_data.featured_image? single_variant_data.featured_image.src : false;

      return variant_img_src;
    }

    getVariantDetails(color) {
      return this.getVariantData().filter(data=>data.title.includes(color));
    }

    updateURL() {
      const product_card = this.closest('.product-card_inline-variation');
      if (!this.currentVariant || this.dataset.updateUrl === 'false' || product_card) return;
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateShareUrl() {
      const shareButton = document.getElementById(`Share-${this.dataset.section}`);
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
    }

    updateVariantInput() {
      const product_card = this.closest('.product-card_inline-variation');
      if(product_card) {
          const productForm = this.querySelector(`#product-form-${this.dataset.section}`);
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          // input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
        let $current_var_price = (this.currentVariant.price / 100).toFixed(2);
        let $current_var_price_money = `₪ ${$current_var_price}`;
        document.querySelectorAll(".product__info-wrapper .change-price").forEach((e) => {
          e.innerHTML = $current_var_price_money;
          e.classList.add("price-updated");
        });
        // update 100gm price
        const element = document.querySelector('.variant_size_number');
        const text = element?.textContent || '';
        const numberOnly = text.replace(/[^\d.]/g, '');
        const price = $current_var_price;
        const onlyNumbers = numberOnly;
        const pricePer100g = (price * 100) / onlyNumbers;
        const truncatedPrice = Math.floor(pricePer100g * 100) / 100;
        document.querySelectorAll(".product__info-wrapper .variant_gram_price price").forEach((e) => {
          e.innerHTML = truncatedPrice.toFixed(2);
        });
      }
    }

    updateVariantStatuses() {
      const product_card = this.closest('.product-card_inline-variation');
      const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
      const inputWrappers = [...this.querySelectorAll('.product-form__input')];
      inputWrappers.forEach((option, index) => {
        if (index === 0) return;
        const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
        if(inputWrappers[index - 1].querySelector(':checked')){
          const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
          const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
          this.setInputAvailability(optionInputs, availableOptionInputsValue)
          if(product_card && option.classList.contains('visually-hidden')) {
            product_card.closest('.product-card-wrapper').querySelector('.card-variation-color');
            const optionInputsVariant = [...product_card.closest('.product-card-wrapper').querySelector('.card-variation-color').querySelectorAll('input[type="radio"], option')]
            this.setInputAvailability(optionInputsVariant, availableOptionInputsValue)
          }
        }
      });
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.innerText = input.getAttribute('value');
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        }
      });
    }

    updatePickupAvailability() {
      const pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;

      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }

    removeErrorMessage() {
      const section = this.closest('section');
      const product_card = this.closest('.product-card_inline-variation');

      if (!section || product_card) return;

      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    renderProductInfo() {
      const requestedVariantId = this.currentVariant.id;
      const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
      const product_card = this.closest('.product-card_inline-variation');

      if(product_card) {
        fetch(`${this.dataset.url}?variant=${requestedVariantId}`)
        .then((response) => response.text())
        .then((responseText) => {
          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const raw_html = new DOMParser().parseFromString(responseText, 'text/html');
          const html = raw_html.querySelector('.single_main_product_wrapper');

          // const destination = document.getElementById(`price-${this.dataset.section}`);
          // const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          // const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          // const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          // const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          // const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

          // if (source && destination) destination.innerHTML = source.innerHTML;
          // if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          // if (skuSource && skuDestination) {
          //   skuDestination.innerHTML = skuSource.innerHTML;
          //   skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          // }

          // const price = document.getElementById(`price-${this.dataset.section}`);

          // if (price) price.classList.remove('visibility-hidden');

          // if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

          const addButtonUpdated = html.querySelector('.product-form__buttons .product-form__submit');
          this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

          publish(PUB_SUB_EVENTS.variantChange, {data: {
            sectionId,
            html,
            variant: this.currentVariant
          }});
        });
      } else {
        fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {

          // prevent unnecessary ui changes from abandoned selections
          if (this.currentVariant.id !== requestedVariantId) return;

          const html = new DOMParser().parseFromString(responseText, 'text/html')
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

          if (source && destination) destination.innerHTML = source.innerHTML;
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
          }

          const price = document.getElementById(`price-${this.dataset.section}`);
          if (price) price.classList.remove('visibility-hidden');

          if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

          const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
          this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

          //Sale Detected
          
          const productForm = html.getElementById(`product-form-${this.dataset.section}`);
          if (productForm) {
            const product = productForm.closest('.product');
            if (product) {
              const isSale = product.querySelector('.is-sale');
              const saleBadge = product.querySelector('.sale');
              if (saleBadge) {
                if (isSale) {saleBadge.style.display = "inline-block"; } else { saleBadge.style.display = "none"; }
              }
            }
          }



          publish(PUB_SUB_EVENTS.variantChange, {data: {
            sectionId,
            html,
            variant: this.currentVariant
          }});
        });
      }
    }

    toggleAddButton(disable = true, text, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
        if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
          document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "inline-block";
          if(document.querySelector(".backinstock_feature_enable")){
            addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.add("active");
            addButton.classList.add("hidden");
            addButton.closest(".product-form-main-container-outer").classList.add("backinstock-active-main");
            addButton.closest("product-form").classList.add("backinstock-active");
          }
        }
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = window.variantStrings.addToCart;
        if(modifyClass && document.getElementById(`product-form-${this.dataset.section}`).closest('.product') && document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock')){
          document.getElementById(`product-form-${this.dataset.section}`).closest('.product').querySelector('.out-of-stock').style.display = "none";
          if(document.querySelector(".backinstock_feature_enable")){
            addButton.closest(".product-form-main-container-outer").querySelector(".matat-backin-stock-alert").classList.remove("active");
            addButton.classList.remove("hidden");
            addButton.closest(".product-form-main-container-outer").classList.remove("backinstock-active-main");
            addButton.closest("product-form").classList.remove("backinstock-active");
          }
        }
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
      const sku = document.getElementById(`Sku-${this.dataset.section}`);

      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
      if (inventory) inventory.classList.add('visibility-hidden');
      if (sku) sku.classList.add('visibility-hidden');
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }

    changelocationinventory(){
        const variantId = document.querySelector("check-availability").getAttribute("data-selectedVariant");
        const apiUrl = `/apps/matat-comax/get-inventory-locations/${variantId}`;
      
      fetch(apiUrl)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`); 
          }
          return response.json();
        })
        .then(data => {
          console.log("Raw response data:", data); // <-- Add this here
      
          const container = document.querySelector(".location-list-wrap");
          container.innerHTML = "";
          const container_detail = document.querySelector(".location-detail");
          container_detail.innerHTML = "";
      
          // Try accessing 'locations' inside the response if data is not an array
        const inventoryEdges = data?.data?.productVariants?.edges;
      
      if (Array.isArray(inventoryEdges) && inventoryEdges.length > 0) {
        const inventoryLevels = inventoryEdges[0].node?.inventoryItem?.inventoryLevels?.edges;
      
        if (Array.isArray(inventoryLevels)) {
          inventoryLevels.forEach((level, index) => {
            const node = level.node;
            const locationName = node?.location?.name || 'Unknown Location';
            const locationAddressObj = node?.location?.address || {};
            const phone = node?.location?.address?.phone;
            const available = node?.quantities?.[0]?.quantity ?? 'N/A';
            let available_txt = node?.quantities?.[0]?.name;
            const available_qty = Number(available);
            let avilable_icon = "";
            let phonenumber = "";
            const formattedAddress = [
              locationAddressObj.address1,
              locationAddressObj.address2,
              locationAddressObj.city,
              locationAddressObj.province,
              locationAddressObj.zip,
              locationAddressObj.country
            ].filter(Boolean).join(", ");
      
            console.log(`Location: ${locationName}, Available: ${available_qty}`);
      
            // OPTIONAL: append to DOM
            const div = document.createElement("div");
            div.className = "single-location-detail";
            div.setAttribute("data-location", index + 1);
            if (index === 0) {
              div.classList.add("active");
            }
            if(phone){
              phonenumber = ` <div class="single--block">
                <h3>טלפון</h3>
                <a href="tel:${phone}">${phone}</a>
              </div>`;
            }
              
            div.innerHTML = `
            <div class="single-location-wrap center">
              <h2>${locationName}</h2>
              <div class="single--block">
                <h3>כתובת</h3>
                <p>
                  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.009 13.6313C10.383 13.6313 9.04498 12.3102 9.04498 10.6673C9.04498 9.04136 10.3661 7.70333 12.009 7.70333C13.635 7.70333 14.973 9.02443 14.973 10.6673C14.973 12.3102 13.635 13.6313 12.009 13.6313ZM12.009 8.21144C10.654 8.21144 9.55309 9.31236 9.55309 10.6673C9.55309 12.0223 10.654 13.1232 12.009 13.1232C13.364 13.1232 14.4649 12.0223 14.4649 10.6673C14.4649 9.31236 13.364 8.21144 12.009 8.21144Z" fill="#081F2C"></path>
                    <path d="M12.009 20.8296C11.9412 20.8296 11.8904 20.8127 11.8396 20.7619C8.01181 17.4422 6.79233 14.8678 6.16565 13.0047C5.9116 12.2425 5.72529 11.0569 5.70835 10.6673C5.6406 9.0583 6.2334 7.51702 7.38513 6.33141C8.58767 5.095 10.2645 4.3667 12.009 4.3667C13.8382 4.3667 15.6674 5.17968 16.8869 6.53466C17.9539 7.72026 18.4621 9.1938 18.3096 10.7012C18.2419 11.3109 18.1233 12.2256 17.8523 13.0216C17.2087 14.8847 15.9892 17.4422 12.1614 20.7788C12.1275 20.8127 12.0767 20.8296 12.009 20.8296ZM12.009 4.87481C10.4 4.87481 8.85867 5.53537 7.74081 6.68709C6.69071 7.77108 6.14872 9.1938 6.21647 10.6504C6.2334 11.023 6.40278 12.1409 6.6399 12.8353C7.24963 14.6137 8.4183 17.0527 12.009 20.2199C15.6166 17.0527 16.7683 14.6137 17.3781 12.8522C17.6321 12.107 17.7338 11.2432 17.8015 10.6504C17.937 9.29542 17.4797 7.95738 16.5143 6.8734C15.3964 5.62005 13.7027 4.87481 12.009 4.87481Z" fill="#081F2C"></path>
                  </svg>
                  <a href="http://maps.google.com/?q=${formattedAddress}" target="_blank">${formattedAddress}</a>
                </p>
              </div>
            ${phonenumber}
            <div class="single--block">
              <h3>שעות פעילות</h3>
              <p>א׳-ה׳ 09:00-20:00</p>
              <p>ו׳ 09:00-14:00</p>
            </div>
            </div> 
            `;
            document.querySelector(".location-detail").appendChild(div);
            
            const sdiv = document.createElement("div");
            sdiv.className = "single-location";
            sdiv.setAttribute("data-location", index + 1);
            if (index === 0) {
                sdiv.classList.add("active");
            }
            if(available_qty == 0){
              avilable_icon = `
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="9" r="9" fill="#CB333B"></circle>
                <g clip-path="url(#clip0_258_10959)">
                <path d="M9.73292 9.00657L12.848 5.89143C13.0507 5.68881 13.0507 5.36119 12.848 5.15856C12.6453 4.95594 12.3177 4.95594 12.1151 5.15856L8.99995 8.2737L5.88491 5.15856C5.68219 4.95594 5.35467 4.95594 5.15204 5.15856C4.94932 5.36119 4.94932 5.68881 5.15204 5.89143L8.26708 9.00657L5.15204 12.1217C4.94932 12.3243 4.94932 12.652 5.15204 12.8546C5.25302 12.9557 5.3858 13.0064 5.51848 13.0064C5.65116 13.0064 5.78384 12.9557 5.88491 12.8546L8.99995 9.73944L12.1151 12.8546C12.2162 12.9557 12.3488 13.0064 12.4815 13.0064C12.6142 13.0064 12.7469 12.9557 12.848 12.8546C13.0507 12.652 13.0507 12.3243 12.848 12.1217L9.73292 9.00657Z" fill="white"></path>
                </g>
                <defs>
                <clipPath id="clip0_258_10959">
                <rect width="8" height="8" fill="white" transform="translate(5 5)"></rect>
                </clipPath>
                </defs>
                </svg>`;
              available_txt = `לא זמין`;
            }else{
              avilable_icon = `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="9" r="9" fill="#28B446"></circle>
                <g clip-path="url(#clip0_258_10937)">
                <path d="M12.8561 5.94642C12.6813 5.79358 12.4152 5.81084 12.262 5.98599L7.77867 11.1097L5.72817 8.92237C5.56902 8.75311 5.30291 8.74469 5.13323 8.90342C4.96354 9.06215 4.9547 9.3291 5.11385 9.49878L7.48224 12.0251C7.56224 12.1097 7.67297 12.1577 7.78961 12.1577H7.79677C7.91592 12.156 8.02792 12.1038 8.10665 12.0141L12.8961 6.54052C13.0489 6.36536 13.0312 6.09968 12.8561 5.94642Z" fill="white"></path>
                </g>
                <defs>
                <clipPath id="clip0_258_10937">
                <rect width="8" height="8" fill="white" transform="translate(5 5)"></rect>
                </clipPath>
                </defs>
              </svg>`;
              available_txt = `זמין`;
            }
            
            
            sdiv.innerHTML = `
            <div class="location-title">
            ${avilable_icon}
            <p>${locationName}</p>
            </div> 
            <span>${available_txt}</span>
            `;
            document.querySelector(".location-list-wrap").appendChild(sdiv);
          });
        } else {
          console.warn("No inventoryLevels found.");
        }
      } else {
        console.warn("No productVariants found.");
      }
        })
        .catch(error => {
          console.error("Fetch error:", error);
        });
    }
  }
  customElements.define('variant-selects', VariantSelects);

  class VariantRadios extends VariantSelects {
    constructor() {
      super();
      if (this.querySelector(".icon-drop")) {
        this.querySelectorAll(".icon-drop").forEach((e) => {
          e.addEventListener("click", (ele) => {
            const clickedLabel = ele.target.closest("label");

            // Close all other accordions
            this.querySelectorAll("label.active").forEach((label) => {
              if (label !== clickedLabel) {
                label.classList.remove("active");
              }
            });

            // Toggle clicked accordion
            clickedLabel.classList.toggle("active");
          });
        });
      }
    }

    setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(input => {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
    }

    updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map((fieldset) => {
        const selected = Array.from(fieldset.querySelectorAll('input')).find(radio => radio.checked);
        if (selected) {
          const spans = selected.closest("fieldset").querySelectorAll("legend span");
          spans.forEach(span => {
            span.innerHTML = selected.value;
          });
          return selected.value;
        }
      });
    }

  }
  customElements.define('variant-radios', VariantRadios);
}else{
  class VariantSelects extends HTMLElement {
    constructor() {
      super();
      this.productsData = [];
      this.selectedVariant = JSON.parse(this.querySelector('script[data-selected-variant]')?.innerHTML?.trim());
      this.handleOptionClick = this.handleOptionClick.bind(this);
    }

    connectedCallback() {
      this.addEventListener('change', (event) => {
        const target = this.getInputForEventTarget(event.target);
        this.updateSelectionMetadata(event);

        publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
          data: {
            event,
            target,
            selectedOptionValues: this.selectedOptionValues,
          },
        });
      });

      this.initCustomSelects();
      this.loadVariantOptions();
    }

    initCustomSelects() {
      // delegate click events to the custom select
      this.addEventListener('click', (e) => {
        const option = e.target.closest('.option:not(.out-of-stock)');
        if (!option) return;

        this.handleOptionClick(e, option);
      });

      // toggle dropdown on click
      this.querySelectorAll('.selected-option').forEach((selectedOption) => {
        selectedOption.addEventListener('click', (e) => {
          const customSelect = e.currentTarget.closest('.custom-select');
          customSelect.classList.toggle('active');
          this.querySelector('.icon-vector').style.transform = customSelect.classList.contains('active')
            ? 'rotate(180deg)'
            : 'rotate(0deg)';
        });
      });

      // Close dropdown when clicking outside
      document.addEventListener('click', (e) => {
        if (!e.target.closest('.custom-select')) {
          this.querySelectorAll('.custom-select').forEach((select) => {
            select.classList.remove('active');
            this.querySelector('.icon-vector').style.transform = select.classList.contains('active')
              ? 'rotate(180deg)'
              : 'rotate(0deg)';
          });
        }
      });
    }

    handleOptionClick(e, option) {
      const customSelect = option.closest('.custom-select');
      const nativeSelect = this.querySelector('.select__select');
      const selectedOption = customSelect.querySelector('.selected-option');
      const optionValue = option.dataset.optionValueId || option.textContent.trim();

      // 1. update the native select
      if (nativeSelect) {
        const optionToSelect = Array.from(nativeSelect.options).find(
          (opt) => opt.value === optionValue || opt.textContent.trim() === option.textContent.trim()
        );

        if (optionToSelect) {
          optionToSelect.setAttribute('selected', 'selected');
          nativeSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }

      // 2. update the selected option
      if (selectedOption) {
        const selectedText = selectedOption.querySelector('.selected-text');
        if (selectedText) {
          selectedText.textContent = option.textContent.replace(' - Out of stock', '').trim();
        }

        // update the swatch
        const optionSwatch = option.querySelector('.option-swatch');
        const selectedSwatch = selectedOption.querySelector('.dropdown-swatch .swatch');
        if (optionSwatch && selectedSwatch) {
          selectedSwatch.style.cssText = optionSwatch.style.cssText;
        }
      }

      // 3. close the custom select
      customSelect.classList.remove('active');
    }

    updateCustomSelectDisplay(select) {
      if (!select.classList.contains('native-select')) return;
      // create div element with the option attributes and push it to my custom select
      const customSelect = select.closest('.select').querySelector('.custom-select');
      const options = customSelect.querySelector('.options');
      options.innerHTML = '';
      const selectedText = this.querySelector('.selected-text');

      select.querySelectorAll('option').forEach((option) => {
        if (option.value.toUpperCase() === selectedText.textContent.toUpperCase()) {
          return;
        }
        const optionElement = document.createElement('div');
        optionElement.classList.add('option');
        optionElement.textContent = option.textContent;
        optionElement.dataset.optionValueId = option.value;
        optionElement.dataset.handle = option.dataset.handle;

        if (option.disabled) {
          optionElement.classList.add('out-of-stock');
        }

        if (option.dataset.optionSwatchValue) {
          if (optionElement.classList.contains('out-of-stock')) {
            const soldOutText = this.querySelector('.variant-picker-sold-out');
            optionElement.textContent = optionElement.textContent
              .toLocaleLowerCase()
              .replace(` - ${soldOutText?.textContent?.trim().toLocaleLowerCase()}`, '');
            optionElement.innerHTML = `<span class="option-swatch swatch" style="background-image: url(${
              option.dataset.optionSwatchValue
            }),  linear-gradient(#f8f8f800, #ebe6e2);"></span> ${optionElement.textContent.toUpperCase()}`;
            const outOfStockText = document.createElement('span');
            outOfStockText.classList.add('text-out-of-stock');
            outOfStockText.textContent = `${soldOutText?.textContent}`;
            optionElement.appendChild(outOfStockText);
          } else {
            optionElement.innerHTML = `<span class="option-swatch swatch" style="background-image: url(${option.dataset.optionSwatchValue}),  linear-gradient(#f8f8f800, #ebe6e2);"></span> ${option.textContent}`;
          }
        }

        // append the optionElement to the custom select
        options.appendChild(optionElement);
      });

      // add variants count
      let variantCount = select.querySelectorAll('option').length - 1;
      const notAvailableCount = select.querySelectorAll('option:disabled').length;
      variantCount -= notAvailableCount;
      if (variantCount > 0) {
        const newVariantCountElement = document.createElement('div');
        newVariantCountElement.classList.add('variant-count');
        const variantPickerText = this.querySelector('.variant-picker-text');
        newVariantCountElement.textContent = `+ ${variantCount} ${variantPickerText?.textContent}`;
        // append to selected-option element
        const selectedOption = this.querySelector('.custom-select')?.querySelector('.selected-option');
        selectedOption?.appendChild(newVariantCountElement);
      } else {
        // add d-none class to the custom select
        customSelect.parentElement.classList.add('d-none');
      }

      this.querySelector('.custom-select-wrapper').classList.remove('d-none');
    }

    async loadVariantOptions() {
      try {
        this.productsData = await this.fetchProductsData();
        if (this.productsData.length > 0) this.updateVariantOptions();
      } catch (error) {
        console.error('Failed to load variant options:', error);
      }
    }

    updateVariantOptions() {
      const pillFieldset = this.querySelector('.pills');
      const dropdownSelect = this.querySelector('.select__select');

      pillFieldset.innerHTML = '';

      const allVariants = this.productsData.flatMap((product) => product.variants);

      const sizeGroups = {};
      const scentOptions = new Set();

      allVariants.forEach((variant) => {
        const id = variant.id;
        const quantity = this.querySelector(`input[data-variant-id="${id}"]`)?.getAttribute('data-quantity');
        const available = quantity
          ? parseInt(quantity) > parseInt(window.product_min_stock.value) && variant.available
          : variant.available;
        if (!sizeGroups[variant.option1]) {
          sizeGroups[variant.option1] = { available: available, scents: new Set() };
        }
        sizeGroups[variant.option1].scents.add(variant.option2);
        scentOptions.add(variant.option2);
      });

      const initialSelected = { ...this.selectedVariant };

      const allSizes = Object.keys(sizeGroups).sort((a, b) => {
        const numA = parseFloat(a.match(/\d+/)?.[0]) || Infinity;
        const numB = parseFloat(b.match(/\d+/)?.[0]) || Infinity;
        return numA - numB || a.localeCompare(b);
      });

      const selectedSize = allSizes.find((size) => size === initialSelected.option1);

      if (scentOptions.size > 1) {
        scentOptions.forEach((scent) => {
          const variant = allVariants.find((v) => {
            return v.option2 === scent && v.option1 === selectedSize;
          });

          if (!variant) return;
          const isSelected = variant.option2 === initialSelected.option2;
          if (isSelected) {
            dropdownSelect?.querySelectorAll('option')?.forEach((option) => {
              if (option.value === scent) {
                option.dataset.handle = variant.handle;
                return;
              }
            });
            return;
          }

          const option = document.createElement('option');
          option.value = scent;
          option.textContent = scent.toUpperCase();
          option.dataset.optionValueId = variant.id;
          option.dataset.handle = variant.handle;
          option.dataset.optionSwatchValue = this.getSwatchUrlForScent(scent);

          dropdownSelect?.appendChild(option);
        });

        dropdownSelect?.dispatchEvent(new Event('change'));
      } else {
        dropdownSelect.parentElement.classList.add('d-none');
      }

      allSizes.forEach((size) => {
        const variant = allVariants.find((v) => v.option1 === size);
        if (!variant) return;

        const isSelected = variant.option1 === initialSelected.option1;
        const { available } = sizeGroups[size];

        const inputId = `${this.id}-size-${size.replace(/\s+/g, '-')}`;

        const input = document.createElement('input');
        input.type = 'radio';
        input.id = inputId;
        input.name = 'Size-1';
        const translatedSize = this.getTranslatedSize(size);
        input.value = translatedSize;
        input.dataset.optionValueId = variant.id;
        if (scentOptions.size > 1) {
          dropdownSelect?.querySelectorAll('option')?.forEach((option) => {
            const scent = option.value;
            const scentVariant = allVariants.find((v) => v.option1 === size && v.option2 === scent);
            if (option.selected === true) {
              if (scentVariant && scentVariant.available) {
                input.dataset.handle = scentVariant.handle;
              } else {
                input.disabled = true;
              }
            } else {
              // wait until the size is selected to check if the scent is available : check line 1392
              option.disabled = true;
            }
          });
        } else {
          input.dataset.handle = variant.handle;
        }
        if (isSelected) input.checked = true;
        if (!available) input.disabled = true;

        const label = document.createElement('label');
        label.htmlFor = inputId;
        label.textContent = translatedSize;
        if (!available) {
          const span = document.createElement('span');
          span.className = 'visually-hidden label-unavailable';
          span.textContent = 'Variant sold out or unavailable';
          label.appendChild(span);
        }

        pillFieldset.appendChild(input);
        pillFieldset.appendChild(label);
      });

      // check if we need to keep option scent disabled
      dropdownSelect.querySelectorAll('option').forEach((option) => {
        if (option.selected === false) {
          const scentVariant = allVariants.find((v) => v.option1 === selectedSize && v.option2 === option.value);
          if (scentVariant) {
            if (scentVariant.available) {
              option.disabled = false;
            } else {
              // change option vlue to unavailable
              option.textContent = `${option.value} - Out of stock`;
            }
          } else {
            // remove option from the select
            option.remove();
            // don't display the select scent if there is only one option left
            if (dropdownSelect.querySelectorAll('option').length === 1) {
              dropdownSelect.parentElement.classList.add('d-none');
            }
          }
        }
      });

      // Après avoir mis à jour les options natives, synchronisez les custom selects
      this.querySelectorAll('.native-select').forEach((select) => {
        this.updateCustomSelectDisplay(select);
      });
    }

    getTranslatedSize(size) {
      const ecorefill = this.querySelector('.ecorefill')?.textContent?.trim();
      if (size.includes('ECO-REFILL') && ecorefill) {
        return size.replace('ECO-REFILL', ecorefill);
      }
      return size;
    }

    getSwatchUrlForScent(scent) {
      const product = this.productsData.find((p) => p.variants.some((v) => v.option2 === scent));
      return product?.images[0] ? `${product.images[0]}?width=50` : 'unset';
    }

    updateSelectionMetadata({ target }) {
      const { value, tagName } = target;

      if (tagName === 'SELECT' && target.selectedOptions.length) {
        Array.from(target.options)
          .find((option) => option.getAttribute('selected'))
          ?.removeAttribute('selected');

        const selectedOption = target.selectedOptions[0];
        selectedOption.setAttribute('selected', 'selected');
      } else if (tagName === 'INPUT' && target.type === 'radio') {
        const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
        if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
      }
    }

    getInputForEventTarget(target) {
      return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
    }

    async fetchProductsData() {
      let productData = [];
      const masterCode = this.querySelector('.master-code').textContent;
      const collectionUrl = this.querySelector('.collection-url').textContent;

      if (masterCode && collectionUrl) {
        const response = await fetch(`${collectionUrl}/${masterCode}?sections=occ-variants-data`);
        if (!response.ok || response.redirected) {
          console.log('Empty response or redirect detected');
          return [];
        }
        const text = await response.text();
        const responseJSON = JSON.parse(text);
        const htmlString = responseJSON['occ-variants-data'];
        if (!htmlString) {
          console.log('Empty htmlString detected');
          return [];
        } else {
          const parser = new DOMParser();
          const doc = parser.parseFromString(htmlString, 'text/html');
          const scriptElements = doc.querySelectorAll('script[id="ProductJSON"]');

          scriptElements.forEach((script) => {
            const jsonString = script.textContent.trim();
            if (jsonString && jsonString !== 'null') {
              try {
                const data = JSON.parse(jsonString);
                if (data) {
                  productData.push(data);
                }
              } catch (error) {
                console.error('Error parsing JSON:', error);
              }
            }
          });
        }
      }
      const updatedProducts = productData.map((p) => ({
        ...p,
        variants: p.variants?.map((v) => ({ ...v, handle: p.handle })) || [],
      }));

      return updatedProducts;
    }
  }
  customElements.define('variant-selects', VariantSelects);
}


class ProductRecommendations extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    this.initializeRecommendations(this.dataset.productId);
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 400px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
          this.remove();
        }

        if (html.querySelector('.grid__item')) {
          this.classList.add('product-recommendations--loaded');
        }
        var elem = this.querySelector('.grid--related-products');
          var flkty = new Flickity(elem, {
            imagesLoaded: true,
            rightToLeft: true,
            cellAlign: "right",
            pageDots: true,
            prevNextButtons: true,
            wrapAround: true
          });
        })
      .catch((e) => {
        console.error(e);
      });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class BulkAdd extends HTMLElement {
  static ASYNC_REQUEST_DELAY = 250;

  constructor() {
    super();
    this.queue = [];
    this.setRequestStarted(false);
    this.ids = [];
  }

  startQueue(id, quantity) {
    this.queue.push({ id, quantity });

    const interval = setInterval(() => {
      if (this.queue.length > 0) {
        if (!this.requestStarted) {
          this.sendRequest(this.queue);
        }
      } else {
        clearInterval(interval);
      }
    }, BulkAdd.ASYNC_REQUEST_DELAY);
  }

  sendRequest(queue) {
    this.setRequestStarted(true);
    const items = {};

    queue.forEach((queueItem) => {
      items[parseInt(queueItem.id)] = queueItem.quantity;
    });
    this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));

    this.updateMultipleQty(items);
  }

  setRequestStarted(requestStarted) {
    this._requestStarted = requestStarted;
  }

  get requestStarted() {
    return this._requestStarted;
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute('value');
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;

    if (inputValue < event.target.dataset.min) {
      this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
    } else if (inputValue > parseInt(event.target.max)) {
      this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
    } else if (inputValue % parseInt(event.target.step) != 0) {
      this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
    } else {
      event.target.setCustomValidity('');
      event.target.reportValidity();
      event.target.setAttribute('value', inputValue);
      this.startQueue(index, inputValue);
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }
}

if (!customElements.get('bulk-add')) {
  customElements.define('bulk-add', BulkAdd);
}

class CartPerformance {
  static #metric_prefix = 'cart-performance';

  static createStartingMarker(benchmarkName) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    return performance.mark(`${metricName}:start`);
  }

  static measureFromEvent(benchmarkName, event) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`, {
      startTime: event.timeStamp,
    });

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }

  static measureFromMarker(benchmarkName, startMarker) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, startMarker.name, `${metricName}:end`);
  }

  static measure(benchmarkName, callback) {
    const metricName = `${CartPerformance.#metric_prefix}:${benchmarkName}`;
    const startMarker = performance.mark(`${metricName}:start`);

    callback();

    const endMarker = performance.mark(`${metricName}:end`);

    performance.measure(metricName, `${metricName}:start`, `${metricName}:end`);
  }
}

class FooterCollapsible {
  constructor() {
    this.mediaQuery = window.matchMedia('(max-width: 989px)');
    this.init();
  }

  init() {
    if (this.mediaQuery.matches) {
      this.setupCollapsibles();
    }

    this.mediaQuery.addListener((e) => {
      if (e.matches) {
        this.setupCollapsibles();
      } else {
        this.destroyCollapsibles();
      }
    });
  }

  setupCollapsibles() {
    this.collapsibles = document.querySelectorAll('[data-collapsible]');

    this.collapsibles.forEach((item) => {
      item.classList.add('is-collapsed');
      const trigger = item.querySelector('[data-collapsible-trigger]');
      const content = item.querySelector('[data-collapsible-content]');
      const quickLinks = document.querySelector('[data-height]');

      const clickHandler = () => {
        item.classList.toggle('is-collapsed');
        if(item.classList.contains("child_links")){
          const parentheight = item.closest(".footer-block__details-content").offsetHeight;
          const CurrentlyChildHeight = item.classList.contains('is-collapsed') ? 0 : content.classList.contains('footer__list-social') ? 250 : content.scrollHeight;
          const TotalHeight = parentheight + CurrentlyChildHeight;
          content.style.maxHeight = item.classList.contains('is-collapsed') ? 0 : content.classList.contains('footer__list-social') ? '250px' : `${content.scrollHeight}px`;
          item.closest(".footer-block__details-content").style.maxHeight = `${TotalHeight}px`;
          console.log("parentheight",parentheight,"CurrentlyChildHeight",CurrentlyChildHeight)
        }else{
          content.style.maxHeight = item.classList.contains('is-collapsed') ? 0 : content.classList.contains('footer__list-social') ? '250px' : `${content.scrollHeight}px`;
        }
        
        if (!item.classList.contains('is-collapsed')) {
          // Hide the plus and show the minus of the first child of this item
          item.querySelector('.plus').classList.add('medium-hide');
          item.querySelector('.plus').classList.add('small-hide');
          item.querySelector('.minus').classList.remove('medium-hide');
          item.querySelector('.minus').classList.remove('small-hide');
          quickLinks.classList.remove('medium-h-3');
          quickLinks.classList.remove('small-h-3');
        } else {
          item.querySelector('.plus').classList.remove('medium-hide');
          item.querySelector('.plus').classList.remove('small-hide');
          item.querySelector('.minus').classList.add('medium-hide');
          item.querySelector('.minus').classList.add('small-hide');
          quickLinks.classList.add('medium-h-3');
          quickLinks.classList.add('small-h-3');
        }
      };

      item._clickHandler = clickHandler;
      if (trigger) trigger.addEventListener('click', clickHandler);
    });
  }

  destroyCollapsibles() {
    if (this.collapsibles) {
      this.collapsibles.forEach((item) => {
        item.classList.remove('is-collapsed');
        if(item.querySelector('[data-collapsible-trigger]')){
          const trigger = item.querySelector('[data-collapsible-trigger]');
          trigger.removeEventListener('click', item._clickHandler);
        }
        if(item.querySelector('[data-collapsible-content]')){
        const content = item.querySelector('[data-collapsible-content]');
        content.style.maxHeight = '';
        }
      });
    }
  }
}
document.addEventListener('DOMContentLoaded', () => {
  new FooterCollapsible();
});

class SidePanel extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.side-panel__overlay');
    this.content = this.querySelector('.side-panel__content');
    this.closeBtn = this.querySelector('.side-panel__close');

    this.hide = this.hide.bind(this);
    this.handleKeyup = this.handleKeyup.bind(this);
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    // Déplacement safe
    if (!document.body.contains(this)) {
      document.body.appendChild(this);
    }

    // Ajout des listeners
    const closeBtn = this.querySelector('.side-panel__close');
    const overlay = this.querySelector('.side-panel__overlay');

    if (closeBtn) closeBtn.addEventListener('click', () => this.hide());
    if (overlay) overlay.addEventListener('click', () => this.hide());
  }

  show() {
    this.setAttribute('open', '');
    document.body.classList.add('side-panel--open');
    this.focus();
    trapFocus?.(this, this.content);
    document.querySelector('.shopify-section-group-header-group')?.style?.setProperty('z-index', '1');
    const overlay = document.createElement('div');
    overlay.className = 'panel-overlay';
    document.body.appendChild(overlay);
    document.querySelector('header').appendChild(overlay);
    overlay.style.display = 'block';
    overlay.addEventListener('click', () => this.hide());
    this.closeBtn.style.setProperty('display', 'block');
  }

  hide() {
    this.removeAttribute('open');
    document.body.classList.remove('side-panel--open');
    this.dispatchEvent(new CustomEvent('sidepanelClosed'));
    document.querySelector('.shopify-section-group-header-group')?.style?.setProperty('z-index', '4');
    document.querySelectorAll('.panel-overlay').forEach((overlay) => {
      overlay.remove();
    });
    this.closeBtn.style.setProperty('display', 'none');
  }

  handleKeyup(event) {
    if (event.code.toUpperCase() === 'ESCAPE') this.hide();
  }
}

customElements.define('side-panel', SidePanel);

document.querySelectorAll('.panel-trigger').forEach((button) => {
  button.addEventListener('click', () => {
    const panelId = button.getAttribute('data-panel');
    const template = document.querySelector(`#panel-content-${panelId}`);
    const target = document.querySelector('#side-panel-dynamic-content');

    if (template && target) {
      target.innerHTML = ''; // clean previous content
      target.appendChild(template.content.cloneNode(true));
      document.querySelector('#infoPanel').show();
    }
  });
});


// product tab js starts from here
if(document.querySelector(".js-acc-single-trigger")){
  const accSingleTriggers = document.querySelectorAll('.js-acc-single-trigger');
    accSingleTriggers.forEach(trigger => trigger.addEventListener('click', toggleAccordion));
    
    const firstItem = document.querySelector(".js-acc-item");
    if (firstItem) firstItem.classList.add("is-open");

    accSingleTriggers.forEach((trigger) =>
      trigger.addEventListener("click", toggleAccordion)
    );

    function toggleAccordion() {
      const thisItem = this.parentNode;
      const beforeTop = thisItem.getBoundingClientRect().top;

      // Toggle only the clicked one (others remain as is)
      thisItem.classList.toggle("is-open");

      // requestAnimationFrame(() => {
      //   const afterTop = this.getBoundingClientRect().top;
      //   const diff = afterTop - beforeTop - 100;
      //   window.scrollBy(0, diff);
      // });
    }
    
    document.addEventListener('click', function (e) {
    const target = e.target;
    if (target.matches('.tab_block_main ul li a')) {
      e.preventDefault();

      const tabBlockMain = target.closest('.tab_block_main');
      const curTabContentId = target.getAttribute('href');
      const allTabLinks = tabBlockMain.querySelectorAll('ul li a');
      
      allTabLinks.forEach(link => link.classList.remove('active'));
      target.classList.add('active');

      const allTabBlocks = tabBlockMain.querySelectorAll('.tab_content .tab_block');
      allTabBlocks.forEach(block => block.classList.remove('active'));

      const currentTabBlock = tabBlockMain.querySelector(curTabContentId);
      if (currentTabBlock) {
        currentTabBlock.classList.add('active');
      }
    }
    
  });
}



// backin stock feature for product page
if(document.querySelector(".single-main-product-page")){
  function validatePhoneNumber() {
    // Get and trim phone number input
    const phoneNumber = document.getElementById('stock-phone').value.trim();

    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;

    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }
  if(document.getElementById('stock-phone')){
    document.getElementById('stock-phone').addEventListener("keyup", (e)=>{
      let phone_value = e.target.value;
      if(phone_value != ""){
        validatePhoneNumber()
      }else{
        document.getElementById('phoneValidationMsg').textContent = "";
      }
    });
  }
  if(document.querySelector(".matat-stock-notify-submit")){
    document.querySelector(".matat-stock-notify-submit").addEventListener("click", ()=> {
      document.getElementById('phoneValidationMsg').textContent = '';  
      let check_phone = validatePhoneNumber();
      let privacy_checked = document.querySelector(".back_instock_accept_marketing").querySelector("#accept_privacy").checked;
      if (check_phone && privacy_checked) {
                  if(document.querySelector(".accept_marketing_error")){
                    document.querySelector(".accept_marketing_error").style.display="none";
                  }
                  document.getElementById('phoneValidationMsg').style.display="none";
                  // Get data attributes from the button
                  const button = document.querySelector(".matat-stock-notify-submit");
                  const data = {
                      phone: document.getElementById("stock-phone").value, // Assuming there's an input for the phone number
                      dialCode: "972",
                      id: button.getAttribute("data-id"),
                      product_id: button.getAttribute("data-product_id"),
                      action: button.getAttribute("data-action"),
                      title: (button.getAttribute("data-title")),
                      price_varies: JSON.parse(button.getAttribute("data-price_varies")),
                      price: (button.getAttribute("data-price")),
                      price_max: (button.getAttribute("data-price_max")),
                      price_min: (button.getAttribute("data-price_min")),
                      has_only_default_variant: JSON.parse(button.getAttribute("data-has_only_default_variant")),
                      src: button.getAttribute("data-src"),
                      url: button.getAttribute("data-url"),
                      user_id: button.getAttribute("data-user_id"),
                      email: button.getAttribute("data-email"),
                      full_name: button.getAttribute("data-full_name"),
                      variant_id: button.getAttribute("data-variant-id"),
                      variant_title: button.getAttribute("data-variant-title")
                  };

                  fetch(`https://il.loccitane.com/apps/text-me/restock-notifications`, {
                      method: 'POST', 
                      headers: {
                        "Content-Type": "application/json",
                        "x-shopify-shop-domain": Shopify.shop
                    },
                    body: JSON.stringify(data)
                  })
                  .then(response => {
                      if (!response.ok) {
                          throw new Error('Network response was not ok');
                      }

                  })
                  .then(data => {
                    document.getElementById('phoneValidationMsg').style.display="block";
                    document.getElementById('phoneValidationMsg').style.color = "green";
                    document.getElementById('phoneValidationMsg').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';  
                  })
                  .catch(error => {
                      console.error('Error:', error);
                  });
      } else {
          if(privacy_checked == false){
            document.querySelector(".accept_marketing_error").style.display="block";
          }else{
            document.querySelector(".accept_marketing_error").style.display="none";
          }
          if(check_phone){
            document.getElementById('phoneValidationMsg').style.display="none";
          }else{
            document.getElementById('phoneValidationMsg').style.color = "red";
            document.getElementById('phoneValidationMsg').textContent = "מספר טלפון לא תקין.";
          }
      }
    })
  }
  
  document.querySelector('[name="id"]').addEventListener("change",(e)=>{
    let variant_change_val = e.target.value;
    document.querySelector(".matat-stock-notify-submit").setAttribute("data-variant-id",variant_change_val);
    document.querySelector(".matat-stock-notify-submit").setAttribute("data-id",variant_change_val);
  })
}
// collection page back in stack
class BackinStockmatat extends HTMLElement{
  constructor() {
    super();
    this.addEventListener("click", () => {
      document.querySelector(".matat-product-card-stock").classList.toggle("active");
      document.body.classList.toggle("overflow-hidden");
      let $AllAttributes = this.attributes;
      this.copyAttributes($AllAttributes);
    })
  }

  copyAttributes(att){
    [...att].forEach((name) => {
      if(name.nodeName != "class"){
        document.querySelector("matat-stock-popup").setAttribute(name.nodeName,name.nodeValue);
      }
    })
  }

}
customElements.define('matat-stock', BackinStockmatat);

// stock popup js starts from here
class matatStockPopup extends HTMLElement{
  constructor() {
    super();
    this.close = this.querySelector(".close-stock-popup");
    this.button = this.querySelector(".stock-popup-button");
    this.input = this.querySelector("#stock-phone-popup");
    this.close.addEventListener("click", () => {
      this.closest(".matat-product-card-stock").classList.remove("active");
      document.body.classList.remove("overflow-hidden");
    })
    this.button.addEventListener("click", (evt) => {
        this.submitStock(evt.target)
    })
    this.addEventListener("click", (evt) => {
      if(evt.target == this){
        this.closest(".matat-product-card-stock").classList.remove("active");
        document.body.classList.remove("overflow-hidden");
      }
    })
  }

  validatePhoneNumber(number) {
    // Get and trim phone number input
    const phoneNumber = number.trim();
    // Regex pattern for 10-digit phone number
    const pattern = /^(?:(?:(\+?972|\(\+?972\)|\+?\(972\))?(?:\s|\.|-)?(5[0-9]{1}))|(0[23489]{1})|(0[57]{1}[0-9]))(?:\s|\.|-)?(\d{7}|([1-9]\d{8}))$/;
    // Validate phone number and update message
    const isValid = pattern.test(phoneNumber);
    return isValid;
  }

  submitStock(ele){
  document.getElementById('popup_phoneValidation').textContent = '';   
  let check_phone = this.validatePhoneNumber(this.input.value);
  let privacy_checked = this.querySelector(".back_instock_accept_marketing_popup").querySelector("#accept_privacy").checked;
  if (check_phone && privacy_checked) {
              // Get data attributes from the button
              this.querySelector(".accept_marketing_error_popup").style.display="none";
              const datas = this;
              const data = {
                  phone: this.input.value, // Assuming there's an input for the phone number
                  dialCode: "972",
                  id: datas.getAttribute("data-id"),
                  product_id: datas.getAttribute("data-product_id"),
                  action: datas.getAttribute("data-action"),
                  title: (datas.getAttribute("data-title")),
                  price_varies: JSON.parse(datas.getAttribute("data-price_varies")),
                  price: (datas.getAttribute("data-price")),
                  price_max: (datas.getAttribute("data-price_max")),
                  price_min: (datas.getAttribute("data-price_min")),
                  has_only_default_variant: JSON.parse(datas.getAttribute("data-has_only_default_variant")),
                  src: datas.getAttribute("data-src"),
                  url: datas.getAttribute("data-url"),
                  user_id: datas.getAttribute("data-user_id"),
                  email: datas.getAttribute("data-email"),
                  full_name: datas.getAttribute("data-full_name"),
                  variant_id: datas.getAttribute("data-variant-id"),
                  variant_title: datas.getAttribute("data-variant-title")
              };

              fetch('https://il.loccitane.com/apps/text-me/restock-notifications', {
                  method: 'POST', 
                  headers: {
                      'Content-Type': 'application/json',
                      "x-shopify-shop-domain": Shopify.shop
                  },
                  body: JSON.stringify(data)
              })
              .then(response => {
                  if (!response.ok) {
                      document.getElementById('popup_phoneValidation').textContent = "תגובת הרשת לא הייתה בסדר";
                      setTimeout(function(){
                        document.querySelector(".matat-product-card-stock").classList.remove("active");
                        document.body.classList.remove("overflow-hidden");
                      }, 500);  
                      throw new Error('Network response was not ok');
                  }

              })
              .then(data => {
                document.getElementById('popup_phoneValidation').classList.add("sucess");
                this.displaySuccessMessage("אנו נחזור אליך בהקדם האפשרי, תודה ששלחת");
                document.getElementById('popup_phoneValidation').textContent = 'אנו נחזור אליך ברגע שהמוצר יחזור למלאי';
                setTimeout(function(){
                  document.querySelector(".matat-product-card-stock").classList.remove("active");
                  document.body.classList.remove("overflow-hidden");
                }, 200);  
                
              })
              .catch(error => {
                  console.error('Error:', error);
              });
      } else {
          if(privacy_checked == false){
            this.querySelector(".accept_marketing_error_popup").style.display="block";
          }else{
            this.querySelector(".accept_marketing_error_popup").style.display="none";
          }
          if(check_phone){
            document.getElementById('popup_phoneValidation').textContent = "";
          }else{
            document.getElementById('popup_phoneValidation').classList.remove("sucess");
            document.getElementById('popup_phoneValidation').textContent = "מספר טלפון לא תקין.";
          }
          
      }
  }
  displaySuccessMessage(message) {
    this.displayAlertMessage(message, "success");
  }
  displayAlertMessage(message, type = "error") {
    const alertBox = document.createElement("div");
    alertBox.classList.add("alert-box", type);
    alertBox.textContent = message;

    document.body.appendChild(alertBox);

    setTimeout(() => {
        alertBox.remove();
    }, 5000); // Remove after 5 seconds
  } 
}
customElements.define('matat-stock-popup', matatStockPopup);

// bundle product js
class ProductBundle extends HTMLElement{
        constructor() {
            super();
            console.log("bundle product")
            if(this.querySelector(".bundle-btn")){
                this.querySelector(".bundle-btn").addEventListener("click", (element) => {
                  this.querySelector('.bundle-btn').setAttribute('aria-disabled', true);
                  this.querySelector('.bundle-btn').classList.add('loading');
                  this.querySelector('.bundle-btn .loading-overlay__spinner').classList.remove('hidden');
                  
                    let $selected_variants_id = [];
                    this.querySelectorAll(".bundle-product-card").forEach((e) => {
                      let $variant_id = Number(e.getAttribute("bundle-product-card"));
                      let $Properties_pro = e.dataset.properties;
                      let $vari_avilabel = e.getAttribute("data-avilable");
                      console.log("vari_avilabel",$vari_avilabel)
                      if($Properties_pro){
                          if($vari_avilabel === "true"){
                            var $pass_param = {'id': $variant_id, 'quantity': 1, 'properties': {'_ItemPostion': $Properties_pro}};
                          }
                      }else{
                        if($vari_avilabel === "true"){
                          var $pass_param = {'id': $variant_id,'quantity': 1};
                        }
                      }
                      if ($pass_param) {
                        $selected_variants_id.push($pass_param);
                      }
                    })
                    console.log("selected_variants_id",$selected_variants_id)
                  this.addTocart($selected_variants_id)
              })
            }
            
        }
        connectedCallback(){}

        addTocart(variants){
            const config = fetchConfig('javascript');
            config.headers['X-Requested-With'] = 'XMLHttpRequest';
            config.headers['Content-Type'] = 'application/json';
            // Construct the JSON payload
            const payload = {
                items: variants.map(variant => ({
                    id: variant.id,
                    quantity: variant.quantity,
                    properties: variant.properties ? variant.properties : {}
                }))
            };

            if (this.cart) {
                payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
                payload.sections_url = window.location.pathname;
                this.cart.setActiveElement(document.activeElement);
            }
            config.method = 'POST';
            config.body = JSON.stringify(payload);

            // Send the fetch request
            const response = fetch(`${routes.cart_add_url}`, config)
            .then(response => {
                return response.json();
            }).then((data) => {
                fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
                .then((response) => response.json())
                .then((response) => {
                    let responseFormated = {
                        sections: response
                    }
                    let cart_drawer = document.querySelector('cart-drawer');
                    cart_drawer.renderContents(responseFormated)
                  
                    this.querySelector('.bundle-btn').removeAttribute('aria-disabled', true);
                    this.querySelector('.bundle-btn').classList.remove('loading');
                    this.querySelector('.bundle-btn .loading-overlay__spinner').classList.add('hidden');
                  
                })
                if(document.querySelector("cart-drawer").classList.contains("is-empty")){
                    document.querySelector("cart-drawer").classList.remove("is-empty");
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
        }

        Allvariants(element){
            let getJsonData = JSON.parse(element.querySelector("script[type='application/json']").innerHTML);
            return getJsonData;
        }

        
    }
customElements.define('product-bundle', ProductBundle);


// oncart button click
document.body.addEventListener("click", function (event) {
  const target = event.target;

  // cart-drawer.liquid renders these as "ragister-main-page" / "login-main-page";
  // the register branch used to check "register-main-page" and never fired.
  if (target.classList.contains("ragister-main-page") || target.classList.contains("login-main-page")) {
    const clubPopup = document.querySelector(".club-member-popup-main");
    if (clubPopup) clubPopup.style.display = "flex";
  }
});

 document.addEventListener("DOMContentLoaded", function () { // before removing
      localStorage.removeItem("customer_logged_in");
    });


// Single source of truth for whether the club gift belongs in the cart, shared
// with cart.js so page load and cart updates can't disagree. The gift is only
// earned alongside OTHER products worth at least the configured minimum — its
// own line never counts toward that minimum, and an unset minimum means the
// promotion is not configured rather than "no minimum at all".
window.clubGiftRules = {
  variantId() {
    const id = Number(document.body.getAttribute("data-giftproduct"));
    return Number.isFinite(id) && id > 0 ? id : 0;
  },
  isEligible() {
    return document.body.getAttribute("data-clubmember") === "true";
  },
  // Minimum cart value in cents, or null when it isn't configured.
  minTotal() {
    const amount = Number(document.body.getAttribute("data-minmonthlytotal"));
    return Number.isFinite(amount) && amount > 0 ? amount * 100 : null;
  },
  giftLine(cart) {
    const id = this.variantId();
    if (!id) return null;
    return (cart.items || []).find((item) => Number(item.variant_id) === id) || null;
  },
  otherItems(cart) {
    const id = this.variantId();
    return (cart.items || []).filter((item) => Number(item.variant_id) !== id);
  },
  otherItemCount(cart) {
    return this.otherItems(cart).length;
  },
  // Cart value in cents, excluding the gift's own line.
  qualifyingTotal(cart) {
    return this.otherItems(cart).reduce((sum, item) => {
      const line = Number(item.final_line_price != null ? item.final_line_price : item.line_price) || 0;
      return sum + line;
    }, 0);
  },
  shouldHaveGift(cart) {
    const min = this.minTotal();
    if (min === null || !this.variantId() || !this.isEligible()) return false;
    return this.otherItemCount(cart) > 0 && this.qualifyingTotal(cart) >= min;
  },
  // Mirror the class toggles cart.js performs after a quantity update. Without
  // this, auto-removing the gift can leave the cart empty while the drawer still
  // looks non-empty, so the "cart is empty" block and its collection image never
  // show. Call it after the section re-render — these elements outlive it.
  syncEmptyState(itemCount) {
    const isEmpty = Number(itemCount) === 0;
    document
      .querySelectorAll("cart-drawer, cart-drawer-items, cart-items, #main-cart-footer")
      .forEach((el) => el.classList.toggle("is-empty", isEmpty));
  },
};

// clubmemner gift product to the cart
document.addEventListener("DOMContentLoaded", async function () {
  try {
    const rules = window.clubGiftRules;
    const variantId = rules.variantId();

    // 1. Fetch current cart
    const res = await fetch("/cart.js", { credentials: "same-origin" });
    if (!res.ok) {
      console.error("Failed to fetch cart.js:", res.status, res.statusText);
      return;
    }
    const cart = await res.json();
    const giftItem = rules.giftLine(cart);
    const qualifies = rules.shouldHaveGift(cart);
    console.log(
      "club gift — qualifies:", qualifies,
      "eligible:", rules.isEligible(),
      "min (cents):", rules.minTotal(),
      "other items:", rules.otherItemCount(cart),
      "qualifying total:", rules.qualifyingTotal(cart)
    );

    // 2. Cart already matches the rule — nothing to add or remove.
    if (qualifies === !!giftItem) return;

    // Item count once the gift has been added or removed, so the empty state can
    // be synced below.
    let itemCountAfter = null;

    if (!qualifies) {
      // Empty of other products, below the minimum, or the customer isn't
      // eligible — drop the gift if it slipped in.
      const removeRes = await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: giftItem.key, quantity: 0 }),
      });
      if (!removeRes.ok) {
        throw new Error("Removing club gift failed: " + removeRes.status + " " + removeRes.statusText);
      }
      // change.js returns the updated cart — removing the gift can empty it.
      const updatedCart = await removeRes.json().catch(() => null);
      itemCountAfter = updatedCart ? updatedCart.item_count : null;
      console.log("Club gift removed — cart no longer qualifies. Items left:", itemCountAfter);
    } else {
      // 3. Add gift product
      const addRes = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      if (!addRes.ok) {
        const text = await addRes.text().catch(() => "");
        throw new Error("Add to cart failed: " + addRes.status + " " + addRes.statusText + " " + text);
      }
      // The gift was just added, so the cart is definitely not empty.
      itemCountAfter = 1;
      console.log("Club gift added to cart:", variantId);
    }

    // 5. Refresh cart sections if routes.cart_url exists (Shopify stores often expose routes)
    if (typeof routes !== "undefined" && routes.cart_url) {
      try {
        const sectionRes = await fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`, { credentials: "same-origin" });
        if (sectionRes.ok) {
          const sectionData = await sectionRes.json();
          const cartDrawer = document.querySelector("cart-drawer");
          if (cartDrawer && typeof cartDrawer.renderContents === "function") {
            cartDrawer.renderContents({ sections: sectionData });
          }
        } else {
          console.warn("Failed to fetch cart sections:", sectionRes.status, sectionRes.statusText);
        }
      } catch (e) {
        console.warn("Error refreshing cart sections:", e);
      }
    } else {
      // Fallback: reload cart icon or whole page if you prefer
      console.log("routes.cart_url not available — skip section refresh.");
    }

    // After the re-render so the fresh markup doesn't overwrite it.
    if (itemCountAfter !== null) rules.syncEmptyState(itemCountAfter);
  } catch (err) {
    console.error("Error in gift-auto-add script:", err);
  }
});



